import { render, staticRenderFns } from "./FailNotifyContainer.vue?vue&type=template&id=c350588c&scoped=true"
import script from "./FailNotifyContainer.vue?vue&type=script&lang=js"
export * from "./FailNotifyContainer.vue?vue&type=script&lang=js"
import style0 from "./FailNotifyContainer.vue?vue&type=style&index=0&id=c350588c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c350588c",
  null
  
)

export default component.exports